import { store } from "../store.js";
import { mapGetters } from "vuex";

export const ui_helpers = {
  computed: {
    ...mapGetters({
      backgroundImage: "getBackGroundImage",
      _customerPreferences: "getCustomerPreferences",
      headerLogo: "getCustomerPreferencesHeaderLogo",
      mobilePhoto: "getCustomerPreferencesMobilePhoto",
      userType: "auth/userType",
      currentAccountId: "getCurrentAccountId"
    })
  },
  watch: {
    backgroundImage: function(newVal, oldVal) {
      this.getBackGroundStyle();
    },
    headerLogo: function(newVal, oldVal) {
      this.headerImage();
    },
    mobilePhoto: function(newVal, oldVal) {
      this.mobileImage();
    },

  },
  data() {
    return {
      image: "",
      backgroundStyle: ""
    };
  },
  mounted() {
    this.getBackGroundStyle();
  },
  methods: {
    getFontProperty() {
      return this._customerPreferences.Font_properties;
    },
    getLinda() {
      return this._customerPreferences.Linda_motivated;
    },
    logoImage() {
      // let fileType = ".png";
      // let image = appConfig.mainImages.logoImage;
      // if (image == null) {
      //   return;
      // }
      // return require("../assets/" + image + fileType);

      return this._customerPreferences.Header_logo;
    },
    checkImage() {
      let img = new Image();

      img.onload = () => {
      };
      img.src = this.image;
    },
    getBackGroundStyle() {
        if (this.$store.getters.getBackGroundImage == "Error") {
        }  else {
          this.backgroundStyle = `background: url(${this.$store.getters.getBackGroundImage}) no-repeat  center center fixed ;  background-size: 100% auto;`;
          this.image = this.$store.getters.getBackGroundImage;
        this.checkImage();
        }
      // return this.backgroundStyle;
    },
    headerImage() {
      if (this.headerLogo === undefined) {
          return require("../assets/toolkit/logo-tdf.png");
        } else {
        return this.headerLogo;
      }
    },
    mobileImage() {
      if (this.mobilePhoto !== undefined) {
          return this.mobilePhoto;
        }
    },
    androidImage() {
      if (this.androidPhoto !== undefined) {
          return this.androidPhoto;
        }
    },
    goToPage(page, params = null) {
      let o = { name: page };
      if (params != null) o.params = params;
      this.$router.push(o);
    },

    toDataURL(url) {
      fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );
    },

    fileToDataUrl(file) {
      let reader = new FileReader();
      reader.onloadend = function() {
      };
      reader.readAsDataURL(file);
    },

    /**
     * use to navigate to all the end-user components
     * @param {*} page
     * @param {*} params
     */
    goToPage(page, params = "component") {
      this.$router.push({
        name: page,
        params: params
      });
    },

    /**
     * tonavigate to the dashboard and passing paramters to the components
     * @param {*} param0
     */
    showComponents({ main, side, mainParams = null, sideParam = null }) {
      this.$router.push({
        path: "/dashboard",
        name: "DashBoard",
        component: "DashBoard",
        params: {
          type: this.userType,
          account_id: this.$store.getters.getRegion
          // mainComponent: {
          //     component: main,
          //     params: mainParams
          // },
          // sideComponent: {
          //     component: side,
          //     params: sideParam
          // }
        },
        props: true
      });

      // if the route is already mounted it won't send the data so,
      // the data are passed directly through signals
      console.log("I fired");
      window.EventBus.fire("setMainContentComponent", {
        component: main,
        params: mainParams
      });
      window.EventBus.fire("setSideComponentName", {
        component: side,
        params: sideParam
      });
    },

    toggleLeftPane() {
      window.EventBus.fire("toggleLeftPane", {});
    }
  }
};
